import React from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { AdvertEntity } from '../../../domain'
import AdvertEditPage from '../../screens/AdvertEditPage/AdvertEditPage.component'

const AdvertsEdit: React.FC = () => {
  const location = useLocation()
  const params = useParams()
  const fromState = (location.state as { advert?: AdvertEntity } | null)?.advert
  const advertUUID = fromState?.uuid || (params.advertId as string)

  return (
    <AdvertEditPage advertUUID={advertUUID} />
  )
}

export default AdvertsEdit
